<template>
    <div class="user-settings">
        <el-form ref="form" :model="userProfile">

            <el-row v-if="!isReferrer || isAcrReferrer" :gutter="10">
                <el-col :span="12">
                    <el-form-item label="Show Email in Templates" prop="show_email">
                        <el-select
                            :disabled="saving || !Ambition.brokerEmailPhoneOverrides()"
                            class="w-100"
                            v-model="userProfile.user_settings.show_broker_email_in_templates"
                            placeholder="Show Email in Templates"
                        >
                            <el-option label="Tenant Setting" value="global"></el-option>
                            <el-option label="Yes" value="yes"></el-option>
                            <el-option label="No" value="no"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Show Phone in Templates" prop="show_phone">
                        <el-select
                            :disabled="saving || !Ambition.brokerEmailPhoneOverrides()"
                            class="w-100"
                            v-model="userProfile.user_settings.show_broker_phone_in_templates"
                            placeholder="Show Phone in Templates"
                        >
                            <el-option label="Tenant Setting" value="global"></el-option>
                            <el-option label="Yes" value="yes"></el-option>
                            <el-option label="No" value="no"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="isReferrer ? 12 : 24">
                    <el-form-item label="Disable Mouse Drag on Application Card View" prop="disable_card_view_dragging">
                        <el-select :disabled="saving" class="w-100"
                                   v-model="userProfile.user_settings.disable_card_view_dragging">
                            <el-option label="No" value="no"></el-option>
                            <el-option label="Yes" value="yes"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="isReferrer" :span="12">
                    <el-form-item label="Receive Stage Change Notifications" prop="referrer_notifications">
                        <el-select :disabled="saving" class="w-100" v-model="userProfile.referrer_notifications">
                            <el-option label="No" :value="0"></el-option>
                            <el-option label="Yes" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col>
                    <el-form-item label="Disable Hover on Application Card View" prop="disable_card_view_hover">
                        <el-select :disabled="saving" class="w-100"
                                   v-model="userProfile.user_settings.disable_card_view_hover">
                            <el-option label="No" value="no"></el-option>
                            <el-option label="Yes" value="yes"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col>
                    <el-form-item label="Expand All Application Tabs" prop="expand_application_tabs">
                        <el-select :disabled="saving" class="w-100"
                                   v-model="userProfile.user_settings.expand_application_tabs">
                            <el-option label="No" value="no"></el-option>
                            <el-option label="Yes" value="yes"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col>
                    <el-form-item label="Show Assets And Liabilities Full List?"
                                  prop="show_assets_and_liabilities_full_lists">
                        <el-select :disabled="saving" class="w-100"
                                   v-model="userProfile.user_settings.show_assets_and_liabilities_full_lists">
                            <el-option label="No" value="no"></el-option>
                            <el-option label="Yes" value="yes"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>



            <el-row :gutter="10">
                <el-col>
                    <el-form-item label="Show Expenses Full Lists?" prop="show_expenses_full_lists">
                        <el-select :disabled="saving" class="w-100"
                                   v-model="userProfile.user_settings.show_expenses_full_lists">
                            <el-option label="No" value="no"></el-option>
                            <el-option label="Yes" value="yes"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col>
                    <el-form-item label="Remove Applications Filter ?" prop="remove_filter">
                        <div class="fin-flex fin-w-full">
                            <el-select
                                class="fin-w-3/4"
                                multiple
                                collapse-tags
                                v-model="selectedFilterArray"
                                placeholder="Remove Saved Filter"
                                @change="handleRemoveFilter"
                                @clear="clearRemoveFilter"
                            >
                                <el-option v-for="(view, index) in savedFilterArray" :key="index" :label="index"
                                           :value="index"/>
                            </el-select>
                            <el-button class="fin-ml-2 fin-w-1/5" type="success" @click="removeFilter()"
                                       :disabled="_.size(selectedFilterArray) == 0">Remove
                                Filter{{ _.size(selectedFilterArray) > 1 ? "'s" : '' }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="Personal Access Token" prop="application_key">
                <el-input :disabled="saving" v-model="userProfile.personal_access_token" readonly>
                    <el-button slot="append" @click="generateApplicationKey()">Generate Key</el-button>
                </el-input>
            </el-form-item>
        </el-form>

        <el-row>
            <el-col :span="12">
                <el-button
                    class="mt-5"
                    ref="saveUserSettings"
                    :disabled="saving"
                    style="width: 200px"
                    type="primary"
                    @click="saveSettings"
                >
                    {{ saveText }}
                </el-button>
            </el-col>
            <el-col style="text-align: right" :span="12">
                <el-button class="mt-5" @click="clearLocalStorage" type="warning">Clear Local Storage</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>

export default {
    name: "UserSettings",
    data() {
        return {
            saving: false,
            saveText: "Save Settings",
            savedFilterArray: [],
            selectedFilterArray: [],
        }
    },
    props: {
        tenant: {
            required: false
        }
    },
    mounted() {
        this.getSavedFilter()
    },
    computed: {
        brokerOverrides() {
            return Ambition.brokerEmailPhoneOverrides()
        },
        userProfile: {
            get() {
                return this.$store.getters['user/user']
            },
            set(profile) {
                this.$store.dispatch('user/setUser', profile)
            }
        },
        timezones() {
            return this.$store.getters["user/timezones"]
        },
        token() {
            return this.$store.getters["user/token"]
        },
        isReferrer: function () {
            return Ambition.User.isReferrer
        },
        isAcrReferrer() {
            return Ambition.User.isAcrReferrer
        },
    },
    methods: {
        removeFilter() {
            let userId = this.userProfile.id
            const userSettings = Ambition.getGlobal('tenant.user.user_settings.applicationsLists')[userId]
            let userFilter = _.omit(userSettings, this.selectedFilterArray);

            this.$tenant.post("/api/v2/user-settings/removeAppFilters", {
                remove: {'applicationsLists': {[userId]: userFilter}}
            })
                .then(res => {
                    this.$notify({
                        title: "Success!",
                        message: `${_.size(this.selectedFilterArray) > 1 ? 'Filters' : 'Filter'} removed`,
                    })

                    this.savedFilterArray = res.data.applicationsLists[userId]
                    this.selectedFilterArray = []
                }).catch(err => {
                err.output()
            })
        },
        handleRemoveFilter() {
            if (_.size(this.selectedFilterArray) > 0) {
                // console.log('selectedFilterArray', this.selectedFilterArray)
            }
        },
        clearRemoveFilter() {
            this.selectedFilterArray = []
        },
        clearSelectedSources() {
            this.selectedSources = []
        },
        clearSelectedTypes() {
            this.selectedTypes = []
        },
        getSavedFilter() {
            this.$tenant.get("/api/v2/user-settings/getAppFilters").then((res) => {
                console.log('getAppFilters ', res.data)
                this.savedFilterArray = res.data
            }).catch(err => {
                err.output()
            })
        },
        clearLocalStorage() {
            window.localStorage.clear()
            this.$notify({
                title: "Success!",
                message: "You have cleared your local storage.",
            })
        },
        generateApplicationKey() {
            axios
                .put("/api/v2/user-settings/generate-key", [], {
                    headers: {Authorization: `Bearer ${this.token}`},
                })
                .then((res) => {
                    this.userProfile.personal_access_token = res.data.key
                    this.$notify({
                        title: "Success!",
                        message: res.data.message,
                    })
                })
                .catch((err) => {
                    this.$notify({
                        title: "Error!",
                        message: "Unable to update settings",
                    })
                })
        },
        saveSettings() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saving = true
                    this.saveText = "Saving..."

                    axios
                        .post("/admin/account/save-user-settings", {
                            id: this.userProfile.id,
                            profile: {
                                personal_access_token: this.userProfile.personal_access_token,
                                referrer_notifications: this.userProfile.referrer_notifications,
                            },
                            settings: {
                                show_broker_email_in_templates: this.userProfile.user_settings.show_broker_email_in_templates,
                                show_broker_phone_in_templates: this.userProfile.user_settings.show_broker_phone_in_templates,
                                disable_card_view_dragging: this.userProfile.user_settings.disable_card_view_dragging,
                                disable_card_view_hover: this.userProfile.user_settings.disable_card_view_hover,
                                expand_application_tabs: this.userProfile.user_settings.expand_application_tabs,
                                show_assets_and_liabilities_full_lists: this.userProfile.user_settings.show_assets_and_liabilities_full_lists,
                                show_expenses_full_lists: this.userProfile.user_settings.show_expenses_full_lists,
                            },
                        })
                        .then((response) => {
                            this.$notify({
                                title: "Saved!",
                                message: "Your settings were updated.",
                            })
                        })
                        .catch((err) => {
                            this.$notify({
                                title: "Error!",
                                message: "There was an error while updating your profile. Please contact support.",
                            })
                        })
                        .finally(() => {
                            this.saving = false
                            this.saveText = "Save Settings"
                        })
                }
            })
        },
    },
    watch: {
        userProfile: {
            handler(userProfile) {
                if (!Ambition.brokerEmailPhoneOverrides()) {
                    userProfile.user_settings.show_broker_email_in_templates = 'global'
                    userProfile.user_settings.show_broker_phone_in_templates = 'global'
                }
            },
            immediate: true,
            deep: true
        },
        selectedFilterArray: {
            immediate: true,
            deep: true,
            handler: _.debounce(function (newVal) {
                if (_.size(this.selectedFilterArray) > 0) {
                    console.log('selectedFilterArray', this.selectedFilterArray)
                }
            }, 100)
        }
    }
}
</script>

<style lang="scss" scoped>
.user-settings {
    padding: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>
